/**
 *
 */

var Video = (function($) {
  function initVideoSound() {
    $(".home-hero-slide__video").on("click", function(e) {
      e.stopPropagation();

      this.muted = !this.muted;

      $(this).toggleClass("is-unmuted", !this.muted);
    });
  }

  function init() {
    // return early if no corresponding module present
    if (!$(".home-hero-slide--video").length) {
      return;
    }

    initVideoSound();
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Video.init);
